GraficosBaseCtrl.$inject = ['$log', '$scope'];
export default function GraficosBaseCtrl($log, $scope) {

    var vm = this;

    vm.actualizarFiltros = function (valor) {
        $scope.$broadcast('CAMBIA_FILTROS', valor);
    };
}